export const PHResidentSection_fields = [
  {
    label: "Filipino Nationality Count",
    name: "filipinoNationality",
    state: "Input",
    types: ["male", "female"],
  },
  {
    label: "Filipino-Foreign Citizenship",
    name: "filipinoForeign",
    state: "Input",
    types: ["male", "female"],
  },
];

export const LengthOfStaySection_fields = [
  {
    label: "No. of Occupied Rooms",
    name: "noOccupiedRooms",
    state: "Input",
  },
  {
    label: "No. of Available Rooms",
    name: "noAvailableRooms",
    state: "Input",
  },
  {
    label: "Guest Checkin",
    name: "guestCheckin",
    state: "Read-only",
  },
  {
    label: "Guest Extending",
    name: "guestExtending",
    state: "Input",
  },
  {
    label: "Total Guest Night",
    name: "totalGuest",
    state: "Read-only",
  },
  {
    label: "Total Female",
    name: "totalFemale",
    state: "Read-only",
  },
  {
    label: "Total Male",
    name: "totalMale",
    state: "Read-only",
  },
];

export const UnspecifiedResidentSection_fields = [
  {
    label: "Others and Unspecified Residence",
    name: "unspecifiedResident",
    state: "Input",
    types: ["male", "female"],
  },
];
